class EquipmentSpecSheets extends HTMLElement {
  constructor() {
    super();
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
  }

  connectedCallback() {
    this.updateActiveVariant();

    // Listen for variant updates from the product section or document
    const section = this.closest('.shopify-section') || document;
    section.addEventListener('variant:update', this.handleVariantUpdate);
    document.addEventListener('variant:update', this.handleVariantUpdate);
    document.addEventListener('variant:selected', this.handleVariantUpdate);
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section') || document;
    section.removeEventListener('variant:update', this.handleVariantUpdate);
    document.removeEventListener('variant:update', this.handleVariantUpdate);
    document.removeEventListener('variant:selected', this.handleVariantUpdate);
  }

  handleVariantUpdate(event) {
    const variantId = event?.detail?.resource?.id;
    if (variantId) {
      this.showVariant(String(variantId));
    }
  }

  updateActiveVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');
    const initialVariantId = urlVariantId || this.dataset.selectedVariantId;
    if (initialVariantId) {
      this.showVariant(String(initialVariantId));
    }
  }

  showVariant(variantId) {
    const groups = this.querySelectorAll('[data-spec-variant-id]');
    let hasMatchingVariant = false;
    let matchingGroupHasFiles = false;

    groups.forEach((group) => {
      const match = group.dataset.specVariantId === String(variantId);
      group.hidden = !match;
      if (match) {
        hasMatchingVariant = true;
        const count = parseInt(group.dataset.fileCount || '0', 10);
        if (count > 0) {
          matchingGroupHasFiles = true;
        }
      }
    });

    // Handle empty state notice if present
    const emptyNotice = this.querySelector('[data-spec-empty-notice]');
    if (emptyNotice) {
      emptyNotice.hidden = matchingGroupHasFiles;
    }

    // Toggle container visibility if hide-when-empty is enabled
    if (this.dataset.hideWhenEmpty === 'true') {
      this.hidden = !matchingGroupHasFiles;
    } else {
      this.hidden = false;
    }
  }
}

if (!customElements.get('equipment-spec-sheets')) {
  customElements.define('equipment-spec-sheets', EquipmentSpecSheets);
}

export { EquipmentSpecSheets };
